<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<v-card class="transparent">
					<v-card-title class="headline justify-center">Participate in Polls</v-card-title>
					<v-divider class="py-1"/>
					<v-card-text>
						<v-form ref="form">
							<v-text-field outlined v-model="code"
														:rules="[v => !!v || 'Code is required']"
														label="Enter Voter identification Code"/>
						</v-form>
					</v-card-text>
					<v-card-actions class="justify-center">
						<v-btn large @click="checkUser" elevation="5" color="green" class="white--text mb-2">Identify</v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";

export default {
	name: "VotingCode",
	data() {
		return {
			code: "",
		}
	},
	methods: {
		checkUser() {
			if (this.$refs.form.validate()) {
				swal.fire({
					title: 'You are about to start Voting?',
					text: "By Clicking Yes, You Agree to our Terms and Conditions and Data Privacy Policy.",
					icon: 'info',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, I agree!'
				}).then((result) => {
					if (result.value) {
						postRequest('checkVoterCode', {
							code: this.code,
							idnumber: localStorage.getItem('userId'),
							phone: localStorage.getItem('userPhone'),
						}).then(() => {
							this.$router.push({name: 'OnlinePoll'})
						}).catch(e => {
							swal.fire('Invalid credentials', '', 'error')
							this.$router.push({name: 'Check2FA'})
						})

					}
				}).catch(e => {
					console.log(e);
				})

			}
		}
	}
}
</script>

<style scoped>

</style>